var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUngeleseneDokumente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.1 68.3",
    style: {
      enableBackground: "new 0 0 50.1 68.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.9,37.2c-6.3,0-11.4,5.1-11.4,11.4c0,6.3,5.1,11.4,11.4,11.4c6.3,0,11.4-5.1,11.4-11.4 C94.3,42.3,89.2,37.2,82.9,37.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.9,31.7c-9.3,0-16.9,7.6-16.9,16.9s7.6,16.9,16.9,16.9c9.3,0,16.9-7.6,16.9-16.9S92.2,31.7,82.9,31.7z  M82.9,61.7c-7.2,0-13.1-5.9-13.1-13.1c0-7.2,5.9-13.1,13.1-13.1c7.2,0,13.1,5.9,13.1,13.1C96,55.8,90.1,61.7,82.9,61.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.3,0L0.5,14.8L0,15.3v53.1h50.1V0H15.3z M5.7,14.3l8.5-8.5v8.5H5.7z M17.6,11.4v-8h29.1V65H3.4V17.6H16 c0.9,0,1.7-0.8,1.7-1.7v-1.2h22.8v-3.4H17.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 19.9,
    className: "st1",
    width: 30.7,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 28.4,
    className: "st1",
    width: 30.7,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 36.9,
    className: "st1",
    width: 30.7,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 45.4,
    className: "st1",
    width: 30.7,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 53.9,
    className: "st1",
    width: 30.7,
    height: 3.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUngeleseneDokumente);
export default __webpack_public_path__ + "static/media/Ungelesene_Dokumente.f92dea5bc6fdcfce2967dad94efdd722.svg";
export { ForwardRef as ReactComponent };